function Reports(){
    return (
        <div>
            Time Off, Pay Rates, Attendence
        </div>
    )
}

export default Reports;